module.exports = __webpack_public_path__ + "static/media/group.c5acf07d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/group.jpg
// module id = 438
// module chunks = 0